import { GridColumnType } from '@grid'
import { GridPreProcessEditCellProps } from '@mui/x-data-grid'
import { Validator, ValidatorResultType } from '@validators'
import { customerRoleLabel, sortCustomerRoles } from '@src/configs/customerRole.config'

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

dayjs.locale('ko')
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault('Asia/Seoul')

export const customerColumns: GridColumnType = {
	initRow: {
		profileColor: '',
		name: '',
		email: '',
		password: '',
		verifiedYn: 1,
		confirmEmailNewsYn: 0,
		roles: [],
		createdAt: dayjs().format('YYYY-MM-DD HH:mm:ss'),
	},
	fieldToFocus: 'name',
	card: {
		title: 'name',
		subtitle: 'email',
		meta: ['roles', 'verifiedYn', 'confirmEmailNewsYn', 'createdAt'],
	},
	columns: [
		{
			field: 'profileColor',
			headerName: '아바타',
			display: 'flex',
			headerAlign: 'center',
			align: 'center',
			valueGetter: (value, row) => ({
				id: row.id ?? '',
				name: row.name ?? '',
				color: row.profileColor ?? '',
			}),
			sortable: false,
			filterable: false,
			editable: false,
		},
		{
			field: 'name',
			headerName: '이름',
			headerAlign: 'center',
			preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
				const res: ValidatorResultType = Validator.mainCustomer({
					name: params.props.value,
				})

				return {
					...params.props,
					error: !res.name.isValid,
					errorMessage: res.name.message ?? '',
				}
			},
			width: 150,
			editable: true,
		},
		{
			field: 'email',
			headerName: '이메일',
			headerAlign: 'center',
			width: 150,
			editable: true,
		},
		{
			field: 'confirmEmailNewsYn',
			headerName: '이메일 수신여부',
			type: 'boolean',
			headerAlign: 'center',
			valueFormatter: (value: number) => (value === 1 ? true : false),
			width: 160,
			editable: true,
		},
		{
			// 고객 유형(역할). 값은 코드 배열 — 편집은 Customer.page 의 renderEditCell(다중 선택)이 맡고,
			// 저장은 고객 수정과 별도 API(PUT /customer-role/{id})로 나간다.
			field: 'roles',
			headerName: '고객 유형',
			headerAlign: 'center',
			valueFormatter: (value: string[]) =>
				Array.isArray(value) && value.length > 0
					? sortCustomerRoles(value).map(customerRoleLabel).join(' + ')
					: '',
			width: 200,
			editable: true,
		},
		{
			field: 'verifiedYn',
			headerName: '인증여부',
			type: 'boolean',
			headerAlign: 'center',
			valueFormatter: (value: number) => (value === 1 ? true : false),
			width: 70,
			editable: false,
		},
		{
			field: 'password',
			headerName: '패스워드',
			display: 'flex',
			headerAlign: 'center',
			align: 'center',
			width: 100,
			// 버튼이지 입력이 아니다 — Grid 의 renderEditModeCell 이 수정 모드에 맞춰 그린다
			editable: false,
			valueGetter: (value, row) => ({
				...row,
			}),
		},
		{
			field: 'createdAt',
			headerName: '생성날짜',
			type: 'dateTime',
			headerAlign: 'center',
			valueFormatter: (value: string) =>
				value !== '' ? dayjs(value).tz().format('YYYY-MM-DD HH:mm:ss') : '',
			width: 200,
			editable: false,
		},
	],
}
